import { render, staticRenderFns } from "./CertificateNumberCellComponent.vue?vue&type=template&id=4de538c2&"
import script from "./CertificateNumberCellComponent.vue?vue&type=script&lang=js&"
export * from "./CertificateNumberCellComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports